import React, { useEffect, useState } from 'react'
import {useDispatch, useSelector} from "react-redux";
import PropTypes from "prop-types"
import countryCodes from '../Organization/CountryCode';
import { useQuery } from "react-query";
import Select from "react-select";
import { Col, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, FormFeedback } from 'reactstrap';

import * as Yup from "yup";
import { useFormik } from 'formik';
import { UpdatePhoneNumber, getUserProfile } from 'helpers/fakebackend_helper';
import { updatePhoneNumber } from 'store/actions';

const OnUpdateContactModal = props => {
 const dispatch = useDispatch();
 
 const [selectedGroup, setselectedGroup] = useState(null);

 const [phoneNumber, setPhoneNumber] = useState(null);

  const { isOpen, toggle } = props;

  const {isLoading, error, data, isFetching} = useQuery({
    queryKey: ["authUser"], queryFn: getUserProfile
  });

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup);
  }

  const optionGroup = [
    {
      label: "Country Code",
      options: countryCodes
    },
  ];

  const getNumber = () => {
    if(data?.phone_number){
      let len = data?.phone_number.length;
      let number = data?.phone_number.substr(len-10,len);
      let number_code = data?.phone_number.substr(0,len-10);
      const code_label = countryCodes.find(code => code.value === number_code);
      setselectedGroup(code_label);
      setPhoneNumber(number);
    }
  }
  useEffect(() => {
   getNumber();
  }, [data])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
        phone_number: data?.phone_number ? phoneNumber : ''
    },
    validate : (values) => {
       const errors = {};
         if (!values.phone_number) {
           errors.phone_number = 'Please Enter your phone number';
         } else if (
           !/^\d{10}$/.test(values.phone_number)
         ) {
           errors.phone_number = 'Invalid number';
         }
         return errors;
    },
    onSubmit: (values) => {
        toggle();
        const fullPhoneNumber = selectedGroup.value + values.phone_number;
        dispatch(updatePhoneNumber(fullPhoneNumber))
    }
  })

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200, // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100, 
    }),
  };


  return (
    <Modal
     isOpen={isOpen}
     toggle={toggle}
     role="dialog"
     autoFocus={true}
     centered={true}
     className="exampleModal"
     tabIndex="-1"
    >
     <div className="modal-content">
        <ModalHeader toggle={toggle}>
          Update Contact
        </ModalHeader>
        <ModalBody>
          <Form
            className='form-horizontal'
            onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
            }}
          >
            <Row>
              <Col>
                 <div className="custom-flex-container">
                      <div className="mb-3 custom-flex-item">
                        <Label>Select country code</Label>
                        <Select
                          value={selectedGroup}
                          onChange={(selectedValue) => {
                            handleSelectGroup(selectedValue);
                          }}
                          options={optionGroup}
                          className="select2-selection"
                          theme={(theme) => ({
                            ...theme,
                            borderRadius: 0,
                            colors: {
                              ...theme.colors,
                              neutral0: '#222736',
                              neutral5: '#485EC4',
                              neutral10: '#485EC4',
                              neutral60: '#ffffff',
                              neutral70: '#ffffff',
                              neutral80: '#ffffff',
                              neutral90: '#ffffff',
                              primary: '#485EC4',
                            },
                          })}
                          styles={customStyles}
                          required
                        />
                      </div>
                      <div className="mb-3 custom-flex-item">
                        <Label className="form-label">Phone Number</Label>
                        <Input
                          name="phone_number"
                          className="input"
                          placeholder="Phone Number"
                          type="tel"
                          required
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone_number || ""}
                          invalid={
                            validation.touched.phone_number && validation.errors.phone_number ? true : false
                          }
                        />
                        {validation.touched.phone_number && validation.errors.phone_number && (
                          <FormFeedback type="invalid">
                            {validation.errors.phone_number}
                          </FormFeedback>
                        )}
                      </div>
                    </div>
              </Col>
            </Row>
            <Row>
                <div className="text-end">
                    <button
                     type="submit"
                     className="btn btn-success save-user"
                    >
                    Update
                    </button>
                </div>
            </Row>
          </Form>
        </ModalBody>
     </div>
    </Modal>
  )
}

OnUpdateContactModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default OnUpdateContactModal